import presignedExport from '../../services/auth/presignedExport';

angular.module('clientDashboardApp').service(
  'listingService',
  function ($q, $http, $log, $rootScope, pagingService, searchService) {

    function ListingService() {
    }

    function ListingResult() {
      this.results = {};
      this.reportParams = null;
      this.pendingResults = false;
    }

    ListingService.prototype.listingAccuracyReport = (groupId, params) => {
      return $http.get('/dashboard/listingAccuracy/overview/' + groupId, {
        params
      });
    }

    ListingService.prototype.listingAccuracyReportByLocation = (groupId, params) => {
      return $http.get('/dashboard/listingAccuracy/locations/' + groupId, {
        params
      });
    }

    ListingService.prototype.exportListingAccuracyReportByLocation = (groupId, params) => {
      presignedExport.downloadExport('/dashboard/listingAccuracy/export/locations/' + groupId, params)
    }

    ListingService.prototype.exportListingAccuracyReportByProvider = (groupId, params) => {
      presignedExport.downloadExport('/dashboard/listingAccuracy/export/providers/' + groupId, params)
    }

    ListingService.prototype.snapshotSummary = function (groupId) {
      var deferred = $q.defer();

      $http
        .get('/dashboard/listingSummary/group/' + groupId)
        .success(function (data, status, headers, config) {
          deferred.resolve(data);
        })
        .error(function (data, status, headers, config) {
          deferred.reject('Error occurred while summary!');
        });

      return deferred.promise;
    };

    ListingService.prototype.listingReportOld = function (groupId, params) {
      var deferred = $q.defer();

      $http
        .get('/dashboard/listingReport/' + groupId, {
          params: params
        })
        .success(function (data, status, headers, config) {
          var listingResult = new ListingResult();
          listingResult.results = data;
          listingResult.reportParams = {};
          angular.copy(params, listingResult.reportParams);
          listingResult.pendingResults = false;
          deferred.resolve(listingResult);
        })
        .error(function (data, status, headers, config) {
          deferred.reject('Error occurred while summary!');
        });

      return deferred.promise;
    };

    ListingService.prototype.listingReport = function (reportId, groupId, params) {
      var deferred = $q.defer();

      $http
        .get('/dashboard/listingReport/' + reportId + '/' + groupId, {
          params: params
        })
        .success(function (data, status, headers, config) {
          var listingResult = new ListingResult();
          listingResult.results = data;
          listingResult.reportParams = {};
          angular.copy(params, listingResult.reportParams);
          listingResult.pendingResults = false;
          deferred.resolve(listingResult);
        })
        .error(function (data, status, headers, config) {
          deferred.reject('Error occurred while summary!');
        });

      return deferred.promise;
    };

    ListingResult.prototype.export = function () {
      var newExportParams;

      if (this.reportParams) {
        newExportParams = angular.copy(this.reportParams);
        newExportParams.type = "listingsReport";
      }

      return searchService.exportResults(newExportParams);
    };

    ListingService.prototype.listingReportDrillDown = function (reportId, groupId, params, callback) {
      var reportUrl = '/dashboard/listingReport/' + reportId + '/' + groupId + '/drilldown';
      return pagingService.createSearch(reportUrl, params, callback);
    };

    ListingService.prototype.listingFixedURLInfo = function (locationId, provider) {
      var deferred = $q.defer();

      $http
        .get('/listingInfo/' + locationId + '/' + provider)
        .success(function (data, status, headers, config) {
          deferred.resolve(data);
        })
        .error(function (data, status, headers, config) {
          deferred.reject('Error occurred while summary!');
        });

      return deferred.promise;
    };

    ListingService.prototype.getListing = function (params) {
      return $http.get('/v5/listings', {params});
    };

    ListingService.prototype.removeListing = function (listingId) {
      return $http.delete('/v5/listings/' + listingId);
    };

    ListingService.prototype.markListingPrimary = function (listingId) {
      return $http.post('/v5/listings/' + listingId + '/makePrimary', {reason: 'User updated'});
    };

    ListingService.prototype.updateIgnoredMismatchTypes = function (listingId, ignoredMismatchTypes) {
      const p = $http.post('/v5/listings/updateIgnoreMismatchErrors', {
        listingId: listingId,
        ignoredMismatchTypes: ignoredMismatchTypes
      });
      p.then(x => $rootScope.$broadcast('listing:updateIgnoredMismatchTypes'));
      return p
    };

    ListingService.prototype.updateFixedURL = function (createListing) {
      return $http.post('/v5/listings', createListing);
    };

    ListingService.prototype.getRespondableListingIds = function (groupId) {
      return $http.get('/v5/listings/respondableListingIds', {params: {'groupId': groupId}}).then(response => response.data);
    };

    return new ListingService();
  });
